import { render, staticRenderFns } from "./carousel-component.vue?vue&type=template&id=59b378fa&scoped=true&"
import script from "./carousel-component.vue?vue&type=script&lang=js&"
export * from "./carousel-component.vue?vue&type=script&lang=js&"
import style0 from "./carousel-component.vue?vue&type=style&index=0&id=59b378fa&scoped=true&lang=css&"
import style1 from "./carousel-component.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b378fa",
  null
  
)

export default component.exports